export default { sha: '3c8d6aacfd10fafd196a9f586765892bcbe9a86c', buildNumber: 'undefined' }
